import InputField from "components/fields/InputField2";
import TextField from "components/fields/TextField";
import {useEffect, useRef, useState} from "react";
import useAsyncEffect from "use-async-effect";
import axios from "axios";

const Product = () => {

    let [productName, setProductName] = useState('');
    let [productType, setProductType] = useState('');
    let [productCategorySelected, setProductCategory] = useState("")

    let productNameField = document.getElementById("productName")
    let productTypeField = document.getElementById("productType")
    let productCategoryField = document.getElementById("productCategory")

    let productCategories = ["Fans", "Lighting", "Appliances", "Pumps"]

    /*if(sessionStorage.getItem("newProduct-productName") !== null && sessionStorage.getItem("newProduct-productName") !== ""){
        productNameField.value(sessionStorage.getItem("newProduct-productName"))
    }*/

    const handleProductNameChange = (newValue) => {
        setProductName(newValue); // Update state with the new value
        productName = newValue
        sessionStorage.setItem("newProduct-productName", productName)
    };

    const handleProductTypeChange = (newValue) => {
        setProductType(newValue); // Update state with the new value
        productType = newValue
        sessionStorage.setItem("newProduct-productType", productType)
    };

    function handleUserAccessLevelDropdown() {
        const productCategory = document.getElementById("productCategory")
        productCategorySelected = productCategory.options[productCategory.selectedIndex].value
        setProductCategory(productCategory.options[productCategory.selectedIndex].value)
        sessionStorage.setItem("newProduct-productCategory", productCategorySelected)
        //console.log(acl)
    }

    return (
        <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
            {/* Header */}
            <h4 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
                Product Info
            </h4>

            {/* content */}
            {/* inputs */}
            <div className="mt-6 grid grid-cols-2 gap-3">
                <div className="col-span-2 md:col-span-1">
                    <InputField
                        extra="mb-4"
                        label="Product Name"
                        placeholder="eg. Smart Fan"
                        id="productName"
                        type="text"
                        onChange={handleProductNameChange} // Pass the function as prop
                        value={sessionStorage.getItem("newProduct-productName")}
                    />
                    <InputField
                        extra="mb-4"
                        label="Product Type"
                        placeholder="eg. Ceiling Fan"
                        id="productType"
                        type="text"
                        onChange={handleProductTypeChange} // Pass the function as prop
                        value={sessionStorage.getItem("newProduct-productType")}
                    />
                    {/*<InputField
                        extra="mb-4"
                        label="Color"
                        placeholder="eg. purple"
                        id="color"
                        type="text"
                    />*/}
                </div>
                {/* right side */}
                <div className="col-span-2 md:col-span-1">
                    <div>
                        <label
                            htmlFor="currency"
                            className="ml-3 mb-2 text-sm font-bold text-navy-700 dark:text-white"
                        >
                            Product Category
                        </label>
                        <div
                            className="w-full mt-2 rounded-xl border border-gray-200 py-3 px-2.5 text-sm text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800">
                            <select id="productCategory" className="w-full dark:!bg-navy-800"
                                    onChange={handleUserAccessLevelDropdown}>
                                <option value="default">Choose a category</option>
                                {/*<option value="Fans">Fans</option>
                                <option value="Lighting">Lighting</option>
                                <option value="Appliances">Appliances</option>
                                <option value="Pumps">Pumps</option>*/}
                                {productCategories.map((Val) => {
                                    return <option value={Val}>
                                        {Val}
                                    </option>
                                })}
                                {/* Optionally include a check for stored value and set selected attribute */}
                                {sessionStorage.getItem('newProduct-productCategory') && (
                                    <option
                                        key="selected"
                                        value={sessionStorage.getItem('newProduct-productCategory')}
                                        selected
                                    >
                                        {sessionStorage.getItem('newProduct-productCategory')}
                                    </option>
                                )}
                            </select>
                        </div>
                    </div>

                    {/* text area */}
                    {/*<TextField
                        label="Description"
                        placeholder="Short description about the product!"
                        id="textarea"
                        cols="30"
                        rows="7"
                    />*/}
                </div>
            </div>
        </div>
    );
};

export default Product;
